import React from 'react';
import {useSelector} from 'react-redux';
import './MenuDemoTurnBadge.css';
import {selectCurrentPlayer, selectIsGameStarted} from '../../../redux/reducers/sharedStateReducer/selectors';
import {getPlayerHexColor} from '../../../utils/players/getPlayerHexColor';
import PlayerFactionIcon from '../../PlayerFactionIcon/PlayerFactionIcon';
import PlayerPolicyIcon from '../../PlayerPolicyIcon/PlayerPolicyIcon';

/**
 * Чей ход на витрине главного меню: плитка цвета ходящего игрока с иконкой
 * его фракции и — если есть — политики под ней. Только смотреть: не нажимается,
 * без таймера и песочных часов.
 *
 * Раньше здесь стояла кнопка хода матча (CompletePhaseButton) в режиме
 * витрины. После перехода матча на дизайн-систему она стала плитой со
 * счетчиком дел, кольцом таймера и часами — для витрины, где ходят боты или
 * идет запись, это лишнее. Плитка повторяет прежний простой вид той кнопки и
 * от кнопки матча не зависит
 */
const MenuDemoTurnBadge = () => {
  const isGameStarted = useSelector(selectIsGameStarted);
  const currentPlayer = useSelector(selectCurrentPlayer);

  if (!isGameStarted || !currentPlayer) {
    return null;
  }

  return (
    <div
      className="menu-demo-turn-badge"
      style={{backgroundColor: getPlayerHexColor(currentPlayer.color)}}
    >
      <PlayerFactionIcon
        player={currentPlayer}
        skinId={currentPlayer.selectedSkin}
        className="menu-demo-turn-badge_icon"
      />
      <PlayerPolicyIcon
        player={currentPlayer}
        className="menu-demo-turn-badge_icon"
      />
    </div>
  );
};

export default MenuDemoTurnBadge;
